export * from './contractDetail'

export function setContractDetail (state, payload) {
  const { restructuringDetail, loan, borrower, suretyDetails, files, transferSchedules, callHistories, sendSmsHistories, sendDocHistories, notifications } = payload
  const { interestRateDetails, feeDetails, expenseDetails, paymentRounds, payments, paymentExpenses } = loan
  state.contractDetail = payload;
  state.contractDetailRestructuringDetail = restructuringDetail
  state.contractDetailInterestRateDetails = interestRateDetails
  state.contractDetailBorrower = borrower
  state.contractDetailSuretyDetails = suretyDetails
  state.contractDetailFiles = files
  state.contractDetailCallHistories = callHistories
  state.contractDetailSendSmsHistories = sendSmsHistories
  state.contractDetailSendDocHistories = sendDocHistories
  state.contractDetailNotifications = notifications
  state.contractDetailFeeDetails = feeDetails
  state.contractDetailExpenseDetails = expenseDetails
  state.contractDetailPayments = payments
  state.contractDetailPaymentExpenses = paymentExpenses;
  state.contractDetailTransferSchedules = transferSchedules
  state.contractDetailPaymentRounds = paymentRounds
}

// interestRateDetails
export function setContractDetailInterestRateDetails (state, payload) {
  state.contractDetailInterestRateDetails = payload
}

// suretyDetails
export function setContractDetailSuretyDetails (state, payload) {
  state.contractDetailSuretyDetails = payload
}

export function addContractDetailSuretyDetail (state, payload) {
  state.contractDetailSuretyDetails.push(payload)
}

export function delContractDetailSuretyDetail (state, id) {
  const contractDetailSuretyDetails = state.contractDetailSuretyDetails.filter(item => item.id !== id)
  state.contractDetailSuretyDetails = contractDetailSuretyDetails || []
}

// files
export function setContractDetailFiles (state, payload) {
  state.contractDetailFiles = payload
}

export function addContractDetailFile (state, payload) {
  state.contractDetailFiles.push(payload)
}

export function delContractDetailFile (state, id) {
  const contractDetailFiles = state.contractDetailFiles.filter(item => item.id !== id)
  state.contractDetailFiles = contractDetailFiles || []
}

// callHistories
export function setContractDetailCallHistories (state, payload) {
  state.contractDetailCallHistories = payload
}

export function addContractDetailCallHistory (state, payload) {
  state.contractDetailCallHistories.push(payload)
}

export function delContractDetailCallHistory (state, id) {
  const contractDetailCallHistories = state.contractDetailCallHistories.filter(item => item.id !== id)
  state.contractDetailCallHistories = contractDetailCallHistories || []
}

export function updateContractDetailReceivedStatus (state, payload) {
  const {
    callHistoriesReceivedStatus,
    callHistoriesReceivedAtDateTimeLocalTh,
    callHistoriesReceivedDateTimeLocalTh,
    callHistoriesReceivedBy
  } = payload;

  Object.assign(state.contractDetail, {
    callHistoriesReceivedStatus,
    callHistoriesReceivedAtDateTimeLocalTh,
    callHistoriesReceivedDateTimeLocalTh,
    callHistoriesReceivedBy
  });
}

// sendSmsHistories
export function setContractDetailSendSmsHistories (state, payload) {
  state.contractDetailSendSmsHistories = payload
}

export function addContractDetailSendSmsHistory (state, payload) {
  state.contractDetailSendSmsHistories.push(payload)
}

export function delContractDetailSendSmsHistory (state, id) {
  const contractDetailSendSmsHistories = state.contractDetailSendSmsHistories.filter(item => item.id !== id)
  state.contractDetailSendSmsHistories = contractDetailSendSmsHistories || []
}

// sendDocHistories
export function setContractDetailSendDocHistories (state, payload) {
  state.contractDetailSendDocHistories = payload
}

export function addContractDetailSendDocHistory (state, payload) {
  state.contractDetailSendDocHistories.push(payload)
}

export function delContractDetailSendDocHistory (state, id) {
  const contractDetailSendDocHistories = state.contractDetailSendDocHistories.filter(item => item.id !== id)
  state.contractDetailSendDocHistories = contractDetailSendDocHistories || []
}

// notifications
export function setContractDetailNotifications (state, payload) {
  state.contractDetailNotifications = payload
}

export function addContractDetailNotification (state, payload) {
  state.contractDetailNotifications.push(payload)
}

export function updateContractDetailNotification (state, payload) {
  const { id, ...rest } = payload
  const contractDetailNotifications = state.contractDetailNotifications.map(item => item.id === id ? { ...item, ...rest } : item)
  state.contractDetailNotifications = contractDetailNotifications || []
}

export function delContractDetailNotification (state, id) {
  const contractDetailNotifications = state.contractDetailNotifications.filter(item => item.id !== id)
  state.contractDetailNotifications = contractDetailNotifications || []
}

// feeDetails
export function setContractDetailFeeDetails (state, payload) {
  state.contractDetailFeeDetails = payload
}

export function addContractDetailFeeDetail (state, payload) {
  state.contractDetailFeeDetails.push(payload)
}

export function updateContractDetailFeeDetail (state, payload) {
  const { id, ...rest } = payload
  const contractDetailFeeDetails = state.contractDetailFeeDetails.map(item => item.id === id ? { ...item, ...rest } : item)
  state.contractDetailFeeDetails = contractDetailFeeDetails || []
}

export function delContractDetailFeeDetail (state, id) {
  const contractDetailFeeDetails = state.contractDetailFeeDetails.filter(item => item.id !== id)
  state.contractDetailFeeDetails = contractDetailFeeDetails || []
}

// expenseDetails
export function setContractDetailExpenseDetails (state, payload) {
  state.contractDetailExpenseDetails = payload
}

export function addContractDetailExpenseDetail (state, payload) {
  state.contractDetailExpenseDetails.push(payload)
}

export function updateContractDetailExpenseDetail (state, payload) {
  const { id, ...rest } = payload
  const contractDetailExpenseDetails = state.contractDetailExpenseDetails.map(item => item.id === id ? { ...item, ...rest } : item)
  state.contractDetailExpenseDetails = contractDetailExpenseDetails || []
}

export function delContractDetailExpenseDetail (state, id) {
  const contractDetailExpenseDetails = state.contractDetailExpenseDetails.filter(item => item.id !== id)
  state.contractDetailExpenseDetails = contractDetailExpenseDetails || []
}

// payments
export function setContractDetailPayments (state, payload) {
  state.contractDetailPayments = payload
}

export function addContractDetailPayment (state, payload) {
  state.contractDetailPayments.push(payload)
}

export function updateContractDetailPayment (state, payload) {
  const { id, ...rest } = payload
  const contractDetailPayments = state.contractDetailPayments.map(item => item.id === id ? { ...item, ...rest } : item)
  state.contractDetailPayments = contractDetailPayments || []
}

export function delContractDetailPayment (state, id) {
  const contractDetailPayments = state.contractDetailPayments.filter(item => item.id !== id)
  state.contractDetailPayments = contractDetailPayments || []
}

// paymentExpenses
export function setContractDetailPaymentExpenses (state, payload) {
  state.contractDetailPaymentExpenses = payload
}

export function addContractDetailPaymentExpense (state, payload) {
  state.contractDetailPaymentExpenses.push(payload)
}

export function updateContractDetailPaymentExpense (state, payload) {
  const { id, ...rest } = payload
  const contractDetailPaymentExpenses = state.contractDetailPaymentExpenses.map(item => item.id === id ? { ...item, ...rest } : item)
  state.contractDetailPaymentExpenses = contractDetailPaymentExpenses || []
}

export function delContractDetailPaymentExpense (state, id) {
  const contractDetailPaymentExpenses = state.contractDetailPaymentExpenses.filter(item => item.id !== id)
  state.contractDetailPaymentExpenses = contractDetailPaymentExpenses || []
}

// transferSchedules
export function setContractDetailTransferSchedules (state, payload) {
  state.contractDetailTransferSchedules = payload
}

export function addContractDetailTransferSchedule (state, payload) {
  state.contractDetailTransferSchedules.push(payload)
}

export function delContractDetailTransferSchedule (state, id) {
  const contractDetailTransferSchedules = state.contractDetailTransferSchedules.filter(item => item.id !== id  || item.transferId !== id)
  state.contractDetailTransferSchedules = contractDetailTransferSchedules || []
}

// paymentRounds
export function setContractDetailPaymentRounds (state, payload) {
  state.contractDetailPaymentRounds = payload
}

export function addContractDetailPaymentRounds(state, items) {
  const sortedItems = [...items].sort((a, b) => a.paymentRoundSeq - b.paymentRoundSeq);
  state.contractDetailPaymentRounds.push(...sortedItems);
}


export function delContractDetailPaymentRounds (state, count) {
  const contractDetailPaymentRounds = state.contractDetailPaymentRounds.slice(0, -count)
  state.contractDetailPaymentRounds = contractDetailPaymentRounds || []
}

